import {
    Step, StepDescription, StepIcon, StepIndicator, StepNumber, StepSeparator, StepStatus, StepTitle, Stepper, useSteps,
    Box, Stack, Flex, Text, Button, Divider, Input, FormControl, FormLabel,
    Table, Thead, Tbody, Tr, Th, Td, TableContainer,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure,
    Select, useToast, Checkbox, useColorModeValue, Skeleton, Center, Badge, IconButton, Grid, GridItem, Avatar, AvatarBadge,
    AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
    HStack, Tooltip, Icon, Alert, AlertIcon, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Textarea, InputGroup
} from "@chakra-ui/react";
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';
import Resizer from "react-image-file-resizer";
import { CloseIcon, AttachmentIcon } from '@chakra-ui/icons';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import axiosClient from '../../../axios-client';
import { FiEdit3, FiTrash2 } from 'react-icons/fi';
import { FaFilePdf, FaImage } from 'react-icons/fa';
import { useStateContext } from '../../../context/ContextProvider';
import { handlePriceChange, formatPriceForBackend } from '../../../utils/priceFormatter';
import ReactSelect from 'react-select';


function EditStock() {

    const { user, setToken, setUser, currentBusiness, setCurrentBusiness } = useStateContext()
    const { t } = useTranslation();
    const navigate = useNavigate()
    const location = useLocation()
    const toast = useToast()

    const [imageListe, setimageListe] = useState([]);
    const [selectedImageList, setSelectedImageList] = useState([]);
    const [loadingImg, setLoadingImg] = useState(false)
    const [inputKey, setInputKey] = useState(0);

    const [dataProduit, setDataProduit] = useState([])
    const [titreProduit, setTitreProduit] = useState('')
    const [descriptionProduit, setDescriptionProduit] = useState('')
    const [codeProduit, setCodeProduit] = useState('')
    const [dataStock, setDataStock] = useState([])
    const [filterStatus, setFilterStatus] = useState(null)
    const [filterQuery, setFilterQuery] = useState('')
    const [filterDate, setFilterDate] = useState('')
    const colorbg = useColorModeValue('white', '#2d3748')
    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')
    const [dataHistoriqueProduct, setDataHistoriqueProduct] = useState([])
    const [dataHistoriqueStock, setDataHistoriqueStock] = useState([])


    const [totalQuantity, setTotalQuantity] = useState()
    const [totalPrice, setTotalPrice] = useState()

    //MESSAGES ERROR
    const [messageErrImages, setMessageErrImages] = useState('')
    const [messageErrTitle, setMessageErrTitle] = useState('')
    const [messageErrCode, setMessageErrCode] = useState('')

    const [categoriesOptions, setCategoriesOptions] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(null);

    const fetchDataCategories = async () => {
        try {
            await axiosClient.get(`/categories/getAllCategories/?page_size=100&page=1&&client=${user?.id}&userRole=${user?.role}`).then(res => {

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }

                const categories = res.data.results.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoriesOptions(categories)
            })
        } catch (error) {
            // // console.error('Error : ', error);

        }
    }

    useEffect(() => {
        fetchDataCategories()
    }, [])


    // function display images
    const handleChangeImage = (e) => {
        const images = e.target.files;
        const extensions = ['.png', '.jpg', '.jpeg', '.webp'];

        if (images && images.length > 0) {
            if (selectedImageList.length + images.length > 5) {
                toast({
                    description: t("Vous ne pouvez séléctionner que 5 images au maximum !"),
                    status: 'warning',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'top-center'
                });
                setInputKey((prevKey) => prevKey + 1)
                return
            }
            const selectedImages = Array.from(images);

            selectedImages.forEach(async (image) => {
                if (image.name.length > 60) {
                    toast({
                        description: t("Nom de l'image dépasse 60 caractères! Veuillez modifier le nom ! "),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'top-center'
                    });
                } else if (!extensions.includes(image.name.substring(image.name.lastIndexOf(".")))) {
                    toast({
                        title: t("Erreur d'extension."),
                        description: t("Veuillez modifier l'extension de l'image {'[*.png, *.jpg, *.jpeg, *.webp]'} !"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'top-center'
                    });
                } else {
                    const imageURL = URL.createObjectURL(image);
                    const uri = await new Promise((resolve, reject) => {
                        Resizer.imageFileResizer(
                            image,
                            451,
                            800,
                            'png',
                            100,
                            0,
                            (uri) => {
                                resolve(uri);
                            },
                            'file'
                        );
                    });
                    setimageListe((prevImageList) => [...prevImageList, uri]);
                    setSelectedImageList((prevSelectedImages) => [...prevSelectedImages, imageURL]);
                }
            });

            // Reset the input value after processing all selected images
            setInputKey((prevKey) => prevKey + 1)
        }
    };


    const fetchData = async (id) => {
        await axiosClient.get(`/products/${id}/?business=${currentBusiness.id}`).then((res => {
            setTitreProduit(res.data.title)
            setDescriptionProduit(res.data.description)
            setCodeProduit(res.data.code || '')
            setSelectedCategory(res.data.category)
            setTotalPrice(res.data.total_price)
            setTotalQuantity(res.data.total_quantity)

            setSelectedImageList(() => {
                let data = []
                for (let index = 0; index < res.data.images.length; index++) {

                    data.push(res.data.images[index].image)
                }
                return data
            })
            setimageListe(() => {
                let data = []
                for (let index = 0; index < res.data.images.length; index++) {
                    data.push(res.data.images[index].image)
                }
                return data
            })
            setDataStock(res.data.stock.filter(e => e.is_deleted === false))

            //Historique
            // setDataHistoriqueProduct(res.data.historique || [])
        }))
    }

    useEffect(() => {

        fetchData(location.state.id)

    }, [])

    const updateProduct = async () => {

        if (imageListe.length === 0) {
            setMessageErrImages(t('Il faut ajouter au moins une image !'))
            return;
        }

        if (!titreProduit) {
            setMessageErrTitle(t('Il faut ajouter un titre !'))
            return
        }

        if (!codeProduit || codeProduit.trim() === '') {
            setMessageErrCode(t('Il faut ajouter un code produit !'))
            return
        }

        setMessageErrCode('');

        const resInfo = await updateInfoProduct(location.state.id)
        if (resInfo && resInfo.error) {
            return;
        }

        await updateImageProduct(location.state.id)

        navigate('/My_Stock')
    }

    const updateImageProduct = async (id) => {
        await axiosClient
            .get(`/productImages/?search=${id}`)
            .then((res) => {
                const deleteImagesList = res.data.filter((e) => !imageListe.includes(e.image));
                // console.log("data image : ", deleteImagesList);
                // console.log("image list : ", imageListe);

                // Delete images not present in the updated imageListe
                for (let index = 0; index < deleteImagesList.length; index++) {
                    axiosClient.delete(`/productImages/${deleteImagesList[index].id}/`);
                }

                // Upload new images
                const newImagesToAdd = imageListe.filter((image) => typeof image !== "string");

                const uploadPromises = newImagesToAdd.map(async (newImage) => {
                    const formData = new FormData();
                    formData.append("product", id);
                    formData.append("image", newImage);

                    return await axiosClient.post(`/productImages/`, formData);
                });

                // Wait for all image uploads to complete
                // Promise.all(uploadPromises)
                //     .then(() => {

                //         // Fetch updated service data with images
                //         return axiosClient.get(`/services/${location.state.idService}/`);
                //     })
                //     .then((res) => {
                //         const { images, ...myNewData } = res.data;
                //         navigate('/apa-agency-services');
                //     })
                //     .catch((error) => {
                //         // console.error('Error uploading new images:', error);
                //     });
            })
            .catch((error) => {
                // // console.error('Error fetching existing images:', error);
            });
    }

    const updateInfoProduct = async (id) => {
        // let historique = dataHistoriqueProduct
        // historique.push({
        //     'title': titreProduit,
        //     'description': titreProduit,
        //     'category': selectedCategory,
        //     'user': user.id,
        //     'created_at': new Date().toLocaleString()
        // })
        // console.log('Historique : ', historique);
        const formData = new FormData()
        formData.append('title', titreProduit)
        formData.append('description', descriptionProduit)
        formData.append('code', codeProduit)
        selectedCategory && formData.append('category', selectedCategory)
        formData.append('total_price', formatPriceForBackend(totalPrice))
        // formData.append('historique', JSON.stringify(historique))
        try {
            await axiosClient.patch(`/products/${id}/?business=${currentBusiness.id}`, formData);
            return { success: true };
        } catch (err) {
            // console.log('ERROR : ', err);
            if (err.response && err.response.data && err.response.data.code) {
                if (Array.isArray(err.response.data.code)) {
                    setMessageErrCode(err.response.data.code[0]);
                } else {
                    setMessageErrCode(err.response.data.code);
                }
            } else if (err.response && err.response.data && err.response.data.error) {
                setMessageErrCode(err.response.data.error);
            } else {
                setMessageErrCode(t("Une erreur s'est produite lors de la modification."));
            }
            return { error: true };
        }
    }

    // STOCK
    // Edit
    const { isOpen, onOpen, onClose } = useDisclosure()

    const [dataStockSelected, setDataStockSelected] = useState()
    const [colorInput, setColorInput] = useState('')
    const [sizeInput, setSizeInput] = useState('')
    const [quatityInput, setQuantityInput] = useState('')
    const [purchase_PriceInput, setPurchase_PriceInput] = useState('')
    const [stockWeightInput, setStockWeightInput] = useState('')
    const [weightUnitInput, setWeightUnitInput] = useState('kg')
    const [purchaseDateInput, setPurchaseDateInput] = useState('')
    const [sourceInput, setSourceInput] = useState('')
    const [warehouseInput, setWarehouseInput] = useState('')
    const [receiptsInput, setReceiptsInput] = useState([])
    const [existingReceipts, setExistingReceipts] = useState([])
    const [isReceiptAlertOpen, setIsReceiptAlertOpen] = useState(false);
    const [receiptToDeleteId, setReceiptToDeleteId] = useState(null);
    const [statusInput, setStatusInput] = useState('Disponible');

    const handleQuantityInputChange = (val) => {
        if (val === '' || /^\d+$/.test(val)) {
            setQuantityInput(val);
        }
    }

    const handlePriceInputChange = (val) => {
        const formatted = handlePriceChange(val);
        if (formatted !== null) {
            setPurchase_PriceInput(formatted);
        }
    }

    const handleWeightInputChange = (val) => {
        if (val === '') {
            setStockWeightInput('');
            return;
        }
        let normalized = val.replace(',', '.');
        const regex = /^\d*\.?\d{0,3}$/;
        if (regex.test(normalized)) {
            setStockWeightInput(normalized);
        }
    }

    const getDataForStockSelected = (id) => {
        const selected = dataStock.find(e => e.id === id);
        onOpen()
        setDataStockSelected(selected)

        setColorInput(selected?.color || '')
        setSizeInput(selected?.size || '')
        setQuantityInput(selected?.quantity !== undefined && selected?.quantity !== null ? String(selected.quantity) : '')
        setPurchase_PriceInput(selected?.purchase_price !== undefined && selected?.purchase_price !== null ? String(selected.purchase_price) : '')
        setStockWeightInput(selected?.stock_weight !== undefined && selected?.stock_weight !== null ? String(selected.stock_weight) : '')
        setWeightUnitInput(selected?.weight_unit || 'kg')
        setPurchaseDateInput(selected?.purchase_date || '')
        setSourceInput(selected?.source || '')
        setWarehouseInput(selected?.warehouse || '')
        setStatusInput(selected?.status || 'Disponible')
        
        const legacy = selected?.recu ? [{ id: 'legacy', file: selected.recu, isLegacy: true }] : [];
        setExistingReceipts([...(selected?.receipts || []), ...legacy]);
    }

    const handleDeleteReceipt = (receiptId) => {
        setReceiptToDeleteId(receiptId);
        setIsReceiptAlertOpen(true);
    }

    const confirmDeleteReceipt = () => {
        if (receiptToDeleteId === 'legacy') {
            axiosClient.patch(`/stock/updateStock/?stockId=${dataStockSelected.id}&business=${currentBusiness.id}`, { recu: null })
                .then((res) => {
                    setExistingReceipts(existingReceipts.filter(r => r.id !== 'legacy'));
                    fetchData(location.state.id);
                    toast({ description: t("Ancien reçu supprimé"), status: 'success' });
                    setIsReceiptAlertOpen(false);
                })
                .catch(() => {});
        } else {
            axiosClient.delete(`/stock/deleteReceipt/?receiptId=${receiptToDeleteId}`)
                .then(() => {
                    setExistingReceipts(existingReceipts.filter(r => r.id !== receiptToDeleteId));
                    fetchData(location.state.id);
                    toast({ description: t("Reçu supprimé"), status: 'success' });
                    setIsReceiptAlertOpen(false);
                })
                .catch(() => {});
        }
    }

    const updateStockSelected = async (id) => {
        if (!quatityInput || quatityInput.trim() === '') {
            toast({
                description: t("La quantité est obligatoire."),
                status: 'error',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            });
            return;
        }

        if (!purchase_PriceInput || purchase_PriceInput.trim() === '') {
            toast({
                description: t("Le prix d'achat est obligatoire."),
                status: 'error',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            });
            return;
        }

        const formData = new FormData()

        formData.append('color', colorInput || '')
        formData.append('size', sizeInput || '')
        formData.append('quantity', quatityInput)
        formData.append('purchase_price', formatPriceForBackend(purchase_PriceInput))
        formData.append('stock_weight', stockWeightInput || '')
        formData.append('weight_unit', weightUnitInput || 'kg')
        formData.append('purchase_date', purchaseDateInput || '')
        formData.append('source', sourceInput || '')
        formData.append('warehouse', warehouseInput || '')
        formData.append('status', statusInput || 'Disponible')
        
        receiptsInput.forEach((file) => {
            formData.append('receipts', file);
        });

        await axiosClient.patch(`/stock/updateStock/?stockId=${id}&business=${currentBusiness.id}`, formData)
            .then(async (res) => {
                setTotalQuantity(res.data.total_quantity)
                setTotalPrice(res.data.total_price)
                setDataStock(res.data.stock.filter(e => e.is_deleted === false))

                toast({
                    description: t("Stock modifié avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                })

                setDataStockSelected()
                setColorInput('')
                setSizeInput('')
                setQuantityInput('')
                setPurchase_PriceInput('')
                setStockWeightInput('')
                setWeightUnitInput('kg')
                setPurchaseDateInput('')
                setSourceInput('')
                setWarehouseInput('')
                setStatusInput('Disponible')
                setReceiptsInput([])
                setExistingReceipts([])
                onClose()

            })
            .catch(err => {
                // console.log("ERROR : ", err);
                toast({
                    description: t("Erreur lors de la modification du stock"),
                    status: 'error',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                });
            })
    }

    // DELETE

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const cancelRef = React.useRef()
    const [deletedId, setDeletedId] = useState()

    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setDeletedId(id)
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setDeletedId()
    };

    const deleteStockSelected = async () => {
        await axiosClient.patch(`/stock/deleteStock/?stockId=${deletedId}`).then(async (res) => {
            setTotalQuantity(res.data.total_quantity)
            setTotalPrice(res.data.total_price)
            setDataStock(dataStock.filter(e => e.id !== deletedId))
            onCloseAlert()
        }).catch(err => {
            // console.log("ERROR : ", err);
        })

    }

    return (
        <Stack>
            <Flex>
                <Box w="90%" pt='12px' mb={8}>
                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem >
                            <BreadcrumbLink onClick={() => navigate('/My_Stock')}>{t("Gestion stock")}</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Modifier stock")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>
            </Flex>

            <Flex justify={'center'}>
                <Box w={{ base: '100%', md: '80%', lg: '70%' }}>
                    <Alert rounded={"lg"} status='warning'>
                        <Flex align={"center"}>
                            <AlertIcon />

                            <Text fontWeight="semibold">
                                {t("Attention! Si vous souhaitez mettre à niveau le stock plutôt que de l'éditer, veuillez cliquer sur ce lien")}
                                <Text
                                    textColor={useColorModeValue("gray.700", "gray.400")}
                                    as="span"
                                    onClick={() => {
                                        navigate('/UpgradeStock', {
                                            state: { id: location.state.id }
                                        });
                                    }}
                                    style={{ marginLeft: '5px', textDecoration: 'underline', cursor: 'pointer' }}
                                >
                                    {t("mise à niveau de stock")}
                                </Text>
                            </Text>

                        </Flex>
                    </Alert>
                    <Stack mt={2} pt={3} px={7} bg={useColorModeValue('white', '#212835')} rounded='lg' pb={5}>
                        <Text color={useColorModeValue('gray', 'gray.400')}>{t("Ajouter les images jusqu'au 5 images")}</Text>

                        {messageErrImages && <Alert status='error' variant='left-accent'>
                            <AlertIcon />
                            {messageErrImages}
                        </Alert>}

                        <Flex
                            align={'center'}
                            w={"100%"}
                            // gap={2}
                            px={5}
                            py={5}
                            justify={'center'}
                            // py={{ base: 3, xl: 0 }}

                            minHeight={"100px"}
                        // style={{
                        //     border: '1px dashed lightgray',
                        // }}
                        >
                            {selectedImageList.length === 0 && (
                                <Flex
                                // align={'center'}
                                // justify={'center'}
                                // style={{ width: '100%' }}
                                >
                                    <Button
                                        size={{ base: 'sm', md: 'md' }}
                                        ml={{ base: 0, lg: 5 }}
                                        colorScheme='purple'
                                        variant='outline'
                                    >
                                        <AiOutlinePlus style={{ fontSize: '18px', marginRight: 2 }} />
                                        <Text ml="2" fontWeight="lighter">
                                            {t("Télécharger des images")}
                                        </Text>
                                        <input
                                            key={inputKey}
                                            multiple
                                            type="file"
                                            id="inputGroupFile01"
                                            style={{
                                                position: 'absolute',
                                                left: 0,
                                                top: 0,
                                                height: '100%',
                                                opacity: 0,
                                                cursor: 'pointer',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.cursor = 'pointer')}
                                            onMouseLeave={(e) => (e.target.style.cursor = 'context-menu')}
                                            onChange={handleChangeImage}
                                            accept="image/png,image/jpg,image/jpeg,image/webp"
                                        />
                                    </Button>
                                </Flex>
                            )}
                            <Grid templateColumns={{ base: 'repeat(1,1fr)', sm: 'repeat(3,1fr)', md: 'repeat(3,1fr)', lg: 'repeat(4,1fr)', xl: 'repeat(5,1fr)' }} gap={3}>

                                {selectedImageList &&
                                    selectedImageList.map((val, key) => (
                                        <GridItem>
                                            <Flex
                                                flexDirection={'row'}
                                                w={"100%"}
                                                key={key}
                                                style={{
                                                    position: 'relative',
                                                }}
                                            >
                                                <Avatar
                                                    size={"xl"}
                                                    src={val}
                                                    borderRadius={"10px"}
                                                    style={{

                                                        objectFit: 'contain',
                                                    }}
                                                >
                                                    <AvatarBadge style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        position: 'absolute',
                                                        fontSize: 10,

                                                        cursor: 'pointer',
                                                        // color: '#c7c4c4',
                                                        background: 'black',
                                                        right: '-5%',
                                                        top: '-5%',
                                                    }}  >
                                                        <CloseIcon onClick={() => {
                                                            // deleteimg(key)
                                                            const newImageList = imageListe;
                                                            const deleteItemImageListe = newImageList.splice(key, 1);
                                                            setSelectedImageList(
                                                                selectedImageList.filter((e) => e !== val)
                                                            );
                                                            setimageListe(newImageList);
                                                        }} />
                                                    </AvatarBadge>

                                                </Avatar>




                                            </Flex>
                                        </GridItem>

                                    ))}


                                {selectedImageList.length > 0 && selectedImageList.length < 5 && (
                                    <Flex
                                        align={'center'}
                                        justify={'center'}
                                        style={{
                                            height: '100px',
                                        }}
                                    >
                                        <Button
                                            colorScheme='blue'
                                            variant='outline'
                                        >
                                            <AiOutlinePlus style={{ fontSize: 22 }} />
                                            <input
                                                key={inputKey}
                                                multiple
                                                type="file"
                                                onChange={handleChangeImage}
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '100%',
                                                    top: 0,
                                                    left: 0,
                                                    opacity: 0,
                                                }}
                                                accept="image/png,image/jpg,image/jpeg,image/webp"
                                            />
                                        </Button>
                                    </Flex>
                                )}
                            </Grid>
                        </Flex>
                    </Stack>

                    <Stack mt={3} pt={3} px={7} bg={useColorModeValue('white', '#212835')} rounded='lg' pb={5}>
                        <Text color={useColorModeValue('gray', 'gray.400')}>{t("Informations du produit")}</Text>

                        {messageErrTitle && <Alert status='error' variant='left-accent'>
                            <AlertIcon />
                            {messageErrTitle}
                        </Alert>}

                        <Flex mt={2}>
                            <FormControl display={'flex'} flexDirection={{ base: 'column', md: 'row' }} id='titre' isRequired>
                                <FormLabel color={useColorModeValue('gray', 'gray.400')} w={'80%'}>{t("Titre")}</FormLabel>
                                <Input
                                    id='titre'
                                    type='text'
                                    name='titreProduit'
                                    color={useColorModeValue('black', 'gray.400')}
                                    borderColor={useColorModeValue('gray.300', 'gray.500')}
                                    _focus={{ boxShadow: 'none', borderColor: 'gray' }}
                                    placeholder={t('Titre')}
                                    value={titreProduit}
                                    onChange={e => setTitreProduit(e.target.value)}
                                />
                            </FormControl>
                        </Flex>

                        <Flex mt={3}>
                            <FormControl display={"flex"} flexDirection={{ base: 'column', md: 'row' }} id="titre">
                                <FormLabel
                                    color={useColorModeValue('gray', 'gray.400')}
                                    w={"80%"}
                                >
                                    {t("Catégorie")}
                                </FormLabel>
                                <div style={{ width: '104%' }}>
                                    <Select
                                        onChange={e => setSelectedCategory(e.target.value)}
                                        placeholder={t("Choisissez une catégorie")}
                                        value={selectedCategory}
                                        isClearable
                                        isSearchable
                                        name="category"
                                    >
                                        {categoriesOptions.map((val, key) => {
                                            return (
                                                <option key={key} value={val.value}>{val.label}</option>
                                            )
                                        })}
                                    </Select>
                                </div>
                            </FormControl>
                        </Flex>

                        <Flex mt={3}>
                            <FormControl display={'flex'} flexDirection={{ base: 'column', md: 'row' }} id='description'>
                                <FormLabel color={useColorModeValue('gray', 'gray.400')} w={'80%'}>Description</FormLabel>
                                <Textarea
                                    id='description'
                                    name='descriptionProduit'
                                    color={useColorModeValue('black', 'gray.400')}
                                    borderColor={useColorModeValue('gray.300', 'gray.500')}
                                    _focus={{ boxShadow: 'none', borderColor: 'gray' }}
                                    resize={'none'}
                                    lineHeight={1.3}
                                    placeholder='Description'
                                    value={descriptionProduit}
                                    onChange={e => setDescriptionProduit(e.target.value)}
                                >

                                </Textarea>
                            </FormControl>
                        </Flex>

                        {messageErrCode && <Alert mt={2} status='error' variant='left-accent'>
                            <AlertIcon />
                            {messageErrCode}
                        </Alert>}

                        <Flex mt={3}>
                            <FormControl display={'flex'} flexDirection={{ base: 'column', md: 'row' }} id='code'>
                                <FormLabel color={useColorModeValue('gray', 'gray.400')} w={'80%'}>{t("Code produit")}</FormLabel>
                                <Input
                                    id='code'
                                    type='text'
                                    name='codeProduit'
                                    color={useColorModeValue('black', 'gray.400')}
                                    borderColor={useColorModeValue('gray.300', 'gray.500')}
                                    _focus={{ boxShadow: 'none', borderColor: 'gray' }}
                                    placeholder={t('Code produit')}
                                    value={codeProduit}
                                    onChange={e => setCodeProduit(e.target.value)}
                                />
                            </FormControl>
                        </Flex>
                    </Stack>

                    <Stack mt={3} pt={3} pl={2} bg={useColorModeValue('white', '#212835')} rounded='lg' pb={5}>
                        <Text color={useColorModeValue('gray', 'gray.400')} ml={3}>{t("Stock produit")}</Text>

                        {/* Filters Section */}
                        <Flex direction={{ base: 'column', md: 'row' }} gap={4} mb={4} px={3} align="center">
                            <Box w={{ base: '100%', md: '30%' }}>
                                <ReactSelect
                                    isClearable
                                    options={[
                                        { value: 'Disponible', label: t('Disponible') },
                                        { value: 'Épuisé', label: t('Épuisé') },
                                        { value: 'En transit', label: t('En transit') },
                                        { value: 'Endommagé', label: t('Endommagé') }
                                    ]}
                                    value={filterStatus}
                                    onChange={setFilterStatus}
                                    placeholder={t('Filtrer par statut')}
                                    styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: 'transparent',
                                            borderColor: 'gray.200'
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            textAlign: 'left',
                                            backgroundColor: colorbg,
                                            cursor: "pointer",
                                            zIndex: 999
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            color: txtcolor,
                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                            '&:hover': {
                                                backgroundColor: colorbghover,
                                            },
                                            cursor: "pointer"
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: colorbghover,
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: txtcolor,
                                        })
                                    }}
                                />
                            </Box>
                            <Box w={{ base: '100%', md: '45%' }}>
                                <Input
                                    placeholder={t("Recherche par couleur, taille, quantité, prix, poids, source, service...")}
                                    value={filterQuery}
                                    onChange={(e) => setFilterQuery(e.target.value)}
                                    size="md"
                                />
                            </Box>
                            <Box w={{ base: '100%', md: '25%' }}>
                                <Input
                                    type="date"
                                    value={filterDate}
                                    onChange={(e) => setFilterDate(e.target.value)}
                                    size="md"
                                />
                            </Box>
                        </Flex>

                        {dataStock.length !== 0 && <TableContainer mt={3} overflowY={'auto'} maxH={300}>
                            <Table variant='simple'>
                                <Thead>
                                    <Tr>

                                        <Th>{t("Couleur")}</Th>
                                        <Th>{t("Taille")}</Th>
                                        <Th>{t("Quantité")}</Th>
                                        <Th>{t("Statut")}</Th>
                                        <Th>{t("Prix d'achat")}</Th>
                                        <Th>{t("Poids")}</Th>
                                        <Th>{t("Source")}</Th>
                                        <Th>{t("Entrepôt")}</Th>
                                        <Th>{t("Reçu")}</Th>
                                        <Th>{t("Date d'achat")}</Th>
                                        <Th>Options</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>



                                    {(() => {
                                        const filteredStock = dataStock.filter(item => {
                                            if (filterStatus) {
                                                if ((item.status || 'Disponible') !== filterStatus.value) return false;
                                            }
                                            if (filterDate) {
                                                const itemDate = item.purchase_date || item.date_creation?.split('T')[0];
                                                if (itemDate !== filterDate) return false;
                                            }
                                            if (filterQuery.trim() !== '') {
                                                const query = filterQuery.toLowerCase();
                                                const color = (item.color || '').toLowerCase();
                                                const size = (item.size || '').toLowerCase();
                                                const quantity = String(item.quantity || '').toLowerCase();
                                                const price = String(item.purchase_price || '').toLowerCase();
                                                const weight = String(item.stock_weight || '').toLowerCase();
                                                const source = (item.source || '').toLowerCase();
                                                const warehouse = (item.warehouse || '').toLowerCase();

                                                const match = color.includes(query) ||
                                                              size.includes(query) ||
                                                              quantity.includes(query) ||
                                                              price.includes(query) ||
                                                              weight.includes(query) ||
                                                              source.includes(query) ||
                                                              warehouse.includes(query);
                                                if (!match) return false;
                                            }
                                            return true;
                                        });

                                        return filteredStock.map((val, key) => {
                                            return (
                                                <Tr key={key}>
                                                    <Td>{val.color ? val.color : '-'}</Td>
                                                    <Td>{val.size ? val.size : '-'}</Td>
                                                    <Td>{val.quantity}</Td>
                                                    <Td>
                                                        <Badge colorScheme={
                                                            val.status === 'Disponible' ? 'green' :
                                                            val.status === 'Épuisé' ? 'red' :
                                                            val.status === 'En transit' ? 'orange' :
                                                            val.status === 'Endommagé' ? 'yellow' : 'gray'
                                                        }>
                                                            {t(val.status || 'Disponible')}
                                                        </Badge>
                                                    </Td>
                                                    <Td>
                                                        <Flex gap={1}>
                                                            <Text fontWeight={"semibold"}  >{val.purchase_price}</Text> <Text h={"100%"} fontSize={12} >{currentBusiness?.currency}</Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>{val.stock_weight ? `${val.stock_weight} ${val.weight_unit || 'kg'}` : '-'}</Td>
                                                    <Td>{val.source ? val.source : '-'}</Td>
                                                    <Td>{val.warehouse ? val.warehouse : '-'}</Td>
                                                    <Td>
                                                        {((val.receipts && val.receipts.length > 0) || val.recu) ? (
                                                            <HStack spacing={1}>
                                                                {[...(val.receipts || []), ...(val.recu ? [{file: val.recu, isLegacy: true}] : [])].map((r, i) => {
                                                                    const isPdf = r.file?.toLowerCase().endsWith('.pdf');
                                                                    return (
                                                                        <Tooltip key={i} label={`${t("Reçu")} #${i + 1}${r.isLegacy ? ' (Ancien)' : ''}`}>
                                                                            <a href={r.file} target="_blank" rel="noreferrer">
                                                                                <Center
                                                                                    w="28px"
                                                                                    h="28px"
                                                                                    bg={isPdf ? "red.50" : "blue.50"}
                                                                                    color={isPdf ? "red.500" : "blue.500"}
                                                                                    rounded="lg"
                                                                                    transition="all 0.2s"
                                                                                    _hover={{ transform: 'translateY(-2px)', shadow: 'sm', bg: isPdf ? "red.100" : "blue.100" }}
                                                                                    border="1px solid"
                                                                                    borderColor={isPdf ? "red.200" : "blue.200"}
                                                                                >
                                                                                    <Icon as={isPdf ? FaFilePdf : FaImage} fontSize="12px" />
                                                                                </Center>
                                                                            </a>
                                                                        </Tooltip>
                                                                    )
                                                                })}
                                                            </HStack>
                                                        ) : (
                                                            <Text fontSize="xs" color="gray.400">-</Text>
                                                        )}
                                                    </Td>
                                                    <Td>{val.purchase_date ? new Date(val.purchase_date).toLocaleDateString(t('fr-FR')) : new Date(val.date_creation).toLocaleDateString(t('fr-FR'))}</Td>
                                                    <Td>
                                                        <Flex gap={2} justify="space-around">
                                                            <Button p={0} size="sm" variant='outline' colorScheme='green' onClick={() => {
                                                                getDataForStockSelected(val.id)
                                                            }}><FiEdit3 /></Button>
                                                            <Button p={0} size="sm" variant='outline' colorScheme='red' onClick={() => {
                                                                onOpenAlert(val.id)
                                                            }}><FiTrash2 /></Button>

                                                        </Flex>
                                                    </Td>
                                                </Tr>
                                            )
                                        });
                                    })()}

                                </Tbody>
                            </Table>
                        </TableContainer>}

                        {dataStock.length === 0 &&
                            <Text fontSize={18} color="red.400" fontWeight="semibold">
                                {t("Votre stock est actuellement vide.")}

                            </Text>
                        }

                    </Stack>

                    <Stack mt={3} pt={3} px={7} bg={useColorModeValue('white', '#212835')} rounded='lg' pb={5}>
                        <Text color={useColorModeValue('gray', 'gray.400')}>Total</Text>
                        <Flex justifyContent={"space-between"}>
                            <Flex mt={2} gap={2}>
                                <Text textTransform={'uppercase'} color={useColorModeValue('gray', 'gray.400')}>{t("Quantité")} : </Text>
                                <Text color={useColorModeValue('gray', 'gray.200')}>{totalQuantity}</Text>
                            </Flex>
                            <Flex mt={2} gap={2} alignItems="center">

                                <Flex gap={1} alignItems="center">
                                    <Text
                                        textTransform={"uppercase"}
                                        color={useColorModeValue('gray', 'gray.400')}
                                    >
                                        {t("Prix")} /
                                    </Text>
                                    <Text fontSize={12} >{currentBusiness?.currency}</Text>:
                                </Flex>
                                <Input
                                    id="totalPrice"
                                    name="totalPrice"
                                    type="text"
                                    color={useColorModeValue("gray", "gray.200")}
                                    borderColor={useColorModeValue("gray.300", "gray.500")}
                                    _focus={{ boxShadow: "none", borderColor: "gray" }}
                                    placeholder={t("Prix total")}
                                    value={parseFloat(totalPrice).toFixed(2) || ''}
                                    onChange={(e) => {
                                        const formattedValue = handlePriceChange(e.target.value);
                                        if (formattedValue !== null) {
                                            setTotalPrice(formattedValue);
                                        }
                                    }}
                                    w="120px"
                                    size="sm"
                                />
                            </Flex>
                        </Flex>

                    </Stack>

                    <Flex mt={5} justifyContent={'end'}>
                        <Button colorScheme='yellow' size={"sm"} variant={'outline'} onClick={updateProduct}>{t("Modifier")}</Button>
                    </Flex>

                </Box>
            </Flex>

            {/* Modal to update stock */}
            <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t("Modification du stock")} </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>{t("Couleur")}</FormLabel>
                            <Input
                                placeholder={t('Couleur')}
                                name='colorInput'
                                value={colorInput}
                                onChange={e => setColorInput(e.target.value)}
                            />
                        </FormControl>

                        <FormControl mt={2}>
                            <FormLabel>{t("Taille")}</FormLabel>
                            <Input
                                placeholder={t('Taille')}
                                value={sizeInput}
                                onChange={e => setSizeInput(e.target.value)}
                            />
                        </FormControl>

                        <FormControl mt={2} isRequired>
                            <FormLabel>{t("Quantité")}</FormLabel>
                            <Input
                                type="text"
                                placeholder={t('Quantité')}
                                value={quatityInput}
                                onChange={e => handleQuantityInputChange(e.target.value)}
                            />
                        </FormControl>

                        <FormControl mt={2} isRequired>
                            <FormLabel>{t("Prix d'achat")}</FormLabel>
                            <Input
                                type="text"
                                placeholder={t("Prix d'achat")}
                                value={purchase_PriceInput}
                                onChange={e => handlePriceInputChange(e.target.value)}
                            />
                        </FormControl>


                        <FormControl mt={2}>
                            <FormLabel>{t("Poids du stock")}</FormLabel>
                            <InputGroup>
                                <Input
                                    placeholder={t("Poids du stock")}
                                    type="text"
                                    value={stockWeightInput}
                                    onChange={e => handleWeightInputChange(e.target.value)}
                                />
                                <Select
                                    ml={2}
                                    w="120px"
                                    value={weightUnitInput}
                                    onChange={e => setWeightUnitInput(e.target.value)}
                                >
                                    <option value="kg">kg</option>
                                    <option value="g">g</option>
                                    <option value="lb">lb</option>
                                    <option value="oz">oz</option>
                                </Select>
                            </InputGroup>
                        </FormControl>

                        <FormControl mt={2}>
                            <FormLabel>{t("Source")}</FormLabel>
                            <Input
                                placeholder={t("Source")}
                                value={sourceInput}
                                onChange={e => setSourceInput(e.target.value)}
                            />
                        </FormControl>

                        <FormControl mt={2}>
                            <FormLabel>{t("Entrepôt / Service")}</FormLabel>
                            <Input
                                placeholder={t("Entrepôt / Service")}
                                value={warehouseInput}
                                onChange={e => setWarehouseInput(e.target.value)}
                            />
                        </FormControl>

                        <FormControl mt={2}>
                            <FormLabel>{t("Date d'achat")}</FormLabel>
                            <Input
                                type="date"
                                max={new Date().toISOString().split('T')[0]}
                                value={purchaseDateInput}
                                onChange={e => setPurchaseDateInput(e.target.value)}
                            />
                        </FormControl>

                        <FormControl mt={2}>
                            <FormLabel>{t("Statut")}</FormLabel>
                            <Select
                                value={statusInput}
                                onChange={e => setStatusInput(e.target.value)}
                            >
                                <option value="Disponible">{t("Disponible")}</option>
                                <option value="Épuisé">{t("Épuisé")}</option>
                                <option value="En transit">{t("En transit")}</option>
                                <option value="Endommagé">{t("Endommagé")}</option>
                            </Select>
                        </FormControl>

                        <FormControl mt={2}>
                            <FormLabel>{t("Reçus (Max 5, Image/PDF, Max 4Mo)")}</FormLabel>
                            <Box
                                border="2px dashed"
                                borderColor="gray.200"
                                p={4}
                                rounded="xl"
                                textAlign="center"
                                cursor="pointer"
                                _hover={{ borderColor: 'purple.400', bg: 'purple.50' }}
                                position="relative"
                            >
                                <Input
                                    type="file"
                                    multiple
                                    accept="image/*,.pdf"
                                    opacity={0}
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    w="100%"
                                    h="100%"
                                    cursor="pointer"
                                    onChange={async (e) => {
                                        const files = Array.from(e.target.files);
                                        const validFiles = [];
                                        const extensions = ['.png', '.jpg', '.jpeg', '.webp', '.pdf'];
                                        
                                        if (receiptsInput.length + existingReceipts.length + files.length > 5) {
                                            toast({ description: t("Max 5 fichiers au total"), status: 'warning' });
                                            return;
                                        }

                                        for (const file of files) {
                                            const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                                            if (!extensions.includes(ext)) {
                                                toast({ description: `${file.name}: ${t("Format non supporté")}`, status: 'error' });
                                                continue;
                                            }
                                            if (file.name.length > 50) {
                                                toast({ description: `${file.name}: ${t("Nom trop long (max 50)")}`, status: 'error' });
                                                continue;
                                            }
                                            if (file.size > 4 * 1024 * 1024) {
                                                toast({ description: `${file.name}: ${t("Fichier trop volumineux (max 4Mo)")}`, status: 'error' });
                                                continue;
                                            }

                                            if (file.type.startsWith('image/')) {
                                                const resized = await new Promise((resolve) => {
                                                    Resizer.imageFileResizer(
                                                        file, 800, 800, 'JPEG', 80, 0,
                                                        (uri) => resolve(uri), 'file'
                                                    );
                                                });
                                                validFiles.push(resized);
                                            } else {
                                                validFiles.push(file);
                                            }
                                        }
                                        setReceiptsInput([...receiptsInput, ...validFiles]);
                                    }}
                                />
                                <AttachmentIcon color="gray.400" mb={2} />
                                <Text fontSize="sm" color="gray.500">
                                    {receiptsInput.length > 0 ? `${receiptsInput.length} ${t("fichiers sélectionnés")}` : t("Cliquez ou glissez des fichiers ici")}
                                </Text>
                            </Box>
                            <Flex wrap="wrap" gap={2} mt={2}>
                                {receiptsInput.map((f, i) => (
                                    <Badge key={i} colorScheme="purple" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                        <a href={URL.createObjectURL(f)} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                            <AttachmentIcon mr={1} fontSize="10px" />
                                            {f.name.substring(0, 10)}...
                                        </a>
                                        <IconButton size="xs" ml={2} icon={<CloseIcon />} variant="ghost" _hover={{ bg: 'red.100', color: 'red.500' }} onClick={() => {
                                            setReceiptsInput(receiptsInput.filter((_, idx) => idx !== i));
                                        }} />
                                    </Badge>
                                ))}
                            </Flex>
                            {existingReceipts.length > 0 && (
                                <>
                                    <Text fontSize="xs" mt={3} mb={1} fontWeight="bold">{t("Reçus enregistrés")}:</Text>
                                    <Flex wrap="wrap" gap={2}>
                                        {existingReceipts.map((r, i) => (
                                            <Badge key={i} colorScheme="green" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                                <a href={r.file} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                    <AttachmentIcon mr={1} fontSize="10px" />
                                                    {t("Reçu")} {i + 1} {r.isLegacy ? `(${t("Ancien")})` : ''}
                                                </a>
                                                <IconButton
                                                    size="xs" ml={2} icon={<CloseIcon />} 
                                                    onClick={() => handleDeleteReceipt(r.id)}
                                                    variant="ghost"
                                                    _hover={{ bg: 'red.100', color: 'red.500' }}
                                                />
                                            </Badge>
                                        ))}
                                    </Flex>
                                </>
                            )}
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='yellow' size="sm" variant='outline' mr={3} onClick={() => updateStockSelected(dataStockSelected?.id)}>
                            {t("Modifier")}
                        </Button>
                        <Button onClick={onClose} size="sm" >{t("Annuler")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Alert to Delete Stolck */}

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={deleteStockSelected} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            <AlertDialog
                isOpen={isReceiptAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={() => setIsReceiptAlertOpen(false)}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer le reçu")}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            {t("êtes-vous sûr de vouloir supprimer ce reçu ?")}
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={() => setIsReceiptAlertOpen(false)}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={confirmDeleteReceipt} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Stack>
    )
}

export default EditStock